import React from 'react';

function VideoPlayer({ videoUrl }) {
  // Check if URL is valid (not an error message)
  const isValidUrl = videoUrl &&
    (videoUrl.startsWith('http') || videoUrl.startsWith('blob:') || videoUrl.startsWith('data:')) &&
    !videoUrl.startsWith('error:') &&
    !videoUrl.startsWith('Error:');

  if (!isValidUrl) {
    return (
      <div className="w-full h-full flex items-center justify-center bg-gray-100 rounded-lg">
        <p className="text-gray-500">No video available</p>
      </div>
    );
  }

  return (
    <div className="relative w-full h-full rounded-lg overflow-hidden bg-black">
      <video
        src={videoUrl}
        controls
        className="w-full h-full object-contain"
        preload="metadata"
      >
        Your browser does not support video playback.
      </video>
    </div>
  );
}

export default VideoPlayer;